<script type="ts">
	import Time from 'svelte-time';
	import Button from '../shared/Button.svelte';
	import { fly, fade } from 'svelte/transition';

	export let event: any;
</script>

{#if event}
	<div class="bg-white flex-grow flex flex-col">
		<img class="w-full" src={event.imageCover} alt={event.name} />

		<div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
			<div class="flex items-center">
				<div class="flex flex-col text-center pr-5 pl-3 ">
					<div class="text-2xl line font-semibold leading-5">
						<Time timestamp={event.startAt} format="DD" />
					</div>
					<div class="text-md font-semibold uppercase leading-5">
						<Time timestamp={event.startAt} format="MMM" />
					</div>
				</div>
				<div>
					{#if event.category}
						<h4 class="text-user-primary font-semibold uppercase text-sm">
							{event.category.name}
						</h4>
					{/if}
					<h1
						class="font-semibold text-lg md:text-2xl inline-block transition duration-500 ease-in-out"
					>
						{event.name}
					</h1>
					<h3 class="font-light opacity-60 text-sm flex items-center">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="16"
							height="16"
							fill="currentColor"
							class="bi bi-clock mr-2"
							viewBox="0 0 16 16"
						>
							<path
								d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"
							/>
							<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
						</svg>
						<Time timestamp={event.startAt} format="HH:mm" /> - <Time
							timestamp={event.endAt}
							format="HH:mm"
						/>
					</h3>
				</div>
			</div>

			<div class="py-6">
				{@html event.description}
			</div>
		</div>
		<div
			class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 flex items-center justify-center"
		>
			<Button width={400}>Solicitar entradas</Button>
		</div>
	</div>
{/if}
